// Packages
import { useState } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { get, includes } from "lodash";
//Utils
import { getFromLocalStorage } from "../utils/webStorage";
import Header from "../component/web/header";
import Footer from "../component/web/footer";

function Index({ component: Component, exact, ...rest }) {
  const location = useLocation();
  if (location.pathname == "/login") {
    window.localStorage.clear();
  }
  const [isLogedIn] = useState(
    Boolean(
      getFromLocalStorage("user") &&
        includes(get(location, "pathname"), "/login")
      //  ||
      // includes(get(location, "pathname"), "/signup")
    )
  );
  return (
    <Route
      exact={exact}
      {...rest}
      render={(props) =>
        isLogedIn ? (
          <Redirect to="/login" />
        ) : (
          <div className="main-component-container">
            {rest?.addHeaderFooter && <Header />}
            <Component {...props} />
            {rest?.addHeaderFooter && <Footer />}
          </div>
        )
      }
    />
  );
}

export default Index;
